<template>
	<inertia-head title="Join TRC" />
	<div class="bg-primary">
		<div class="bg-trc-main">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">Join to the Truly Rich Club</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Enjoy more benefits when you subscribe to
						<strong>GOLD</strong> membership!
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div v-if="flash && flash.title" class="alert alert-danger" role="alert">
			<h3 class="alert-heading fs-5 fw-bold mb-1">{{ flash.title }}</h3>
			<p class="mb-0">{{ flash.message }}</p>
		</div>
		<div v-if="form.errors.subscription" class="alert alert-danger" role="alert">
			<h3 class="alert-heading fs-5 fw-bold mb-1">Please choose subscription</h3>
			<p class="mb-0">{{ form.errors.subscription }}</p>
		</div>
	</div>
	<div class="content mt-5">
		<div class="row">
			<div class="col-8 m-auto">
				<form @submit.prevent="joinTRC">
					<div class="block block-rounded">
						<div class="block-header block-header-default">
							<h3 class="block-title">Choose Subscription - <span class="fw-bold badge bg-primary">GOLD</span></h3>
						</div>
						<div class="block-content">
							<div class="row">
								<div v-if="form.errors.subscription" class="col-12 text-danger mb-3">
									<i class="fa fa-exclamation-circle"></i>
									{{ form.errors.subscription }}
								</div>
								<div
									class="col-12"
									v-for="product in products"
									:key="product.prod_id"
								>
									<div class="form-check form-block mb-3">
										<input
											v-model="form.subscription"
											class="subscription form-check-input"
											type="radio"
											:id="product.prod_id"
											:value="product.prod_id"
											name="subscription"
										/>
										<label class="form-check-label" :for="product.prod_id">
											<span class="d-flex align-items-center">
												<h6 class="fs-sm mb-0">
													{{ product.membership }}
												</h6>
												<span
													v-if="product.add_display"
													class="badge bg-warning ms-1"
												>
													{{ product.add_display }}
												</span>
											</span>
											<small>&#8369;{{ product.amount }}</small>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="block block-rounded">
						<div class="block-header block-header-default">
							<h3 class="block-title">Choose Payment method</h3>
						</div>
						<div class="block-content">
							<div class="row">
								<div class="col-md-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.mop"
											class="form-check-input"
											type="radio"
											:value="'CARD'"
											id="card"
											name="payment_method"
										/>
										<label class="form-check-label" for="card">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/stripe-logo.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
								<div v-if="payment_available==true" class="col-md-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.mop"
											class="form-check-input"
											type="radio"
											:value="'DRAGONPAY'"
											id="dragonpay"
											name="payment_method"
										/>
										<label class="form-check-label" for="dragonpay">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/dragonpay-logo.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
								<!-- <div class="col-md-4">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.mop"
											class="form-check-input"
											type="radio"
											:value="'BROPAY'"
											id="bropay"
											name="payment_method"
										/>
										<label class="form-check-label" for="bropay">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/bropay-logo.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div> -->
							</div>
							<div v-if="form.mop == 'CARD'">
								<div v-if="members.has_card">
									<div class="form-check form-switch mb-4">
										<input
											v-model="form.use_existing_card"
											class="form-check-input"
											type="checkbox"
											:value="true"
											id="example-switch-default1"
											name="example-switch-default1"
										/>
										<label class="form-check-label" for="example-switch-default1">
											Use existing card
										</label>
									</div>
									<div v-if="form.use_existing_card" class="mb-4">
										<p class="mb-0">
											<span class="fw-semibold">CARD:</span>
											<i>**** **** **** {{ members.card_info.card_last4 }}</i>
											<span class="badge bg-primary ms-2">{{ members.card_info.brand }}</span>
										</p>
									</div>
								</div>
								<div v-if="!form.use_existing_card" class="form-group mb-4">
									<stripe @accept-token="acceptToken" ref="stripe" />
									<div v-if="form.errors.card" class="invalid-feedback d-block">
										<i class="fa fa-exclamation-circle"></i>
										{{ form.errors.card }}
									</div>
								</div>
							</div>
							<div class="my-5">
								<button
									type="submit"
									class="btn btn-lg btn-alt-primary w-100 py-3 fw-semibold"
									:disabled="
										form.processing ||
										(form.mop === 'CARD' && !form.token && !form.use_existing_card) ||
										!form.subscription
									"
								>
									<span v-if="!form.processing">Pay Now</span>
									<span v-else>
										<div class="spinner-border spinner-border-sm text-dark" role="status" >
											<span class="sr-only mr-1">Please wait...</span>
										</div>
										<span class="mx-2">Please wait...</span>
									</span>
								</button>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted, ref, watch } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import { useForm } from '@inertiajs/inertia-vue3'
import Stripe from '../../../Shared/Components/Stripe'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: AuthLayout,
	props: {
		test 		: String,
		products 	: Object,
		members 	: Object,
		flash 		: Object
	},
	components: {
		Stripe,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const payment_available = ref(true);

		const form = useForm({
			subscription: null,
			mop: 'CARD',
			token: null,
			use_existing_card: props.members.has_card ? true : false,
			test: props.test
		});

		const acceptToken = (token) => {
			form.token = token
		};

		const joinTRC = () => {
			form.post(route('member.bcc.post.join-trc'), {
				preserveState: true,
				preserveScroll: true,
			})
		};

		watch(
			() => form.mop,
			(mop) => {
				
				if(mop=='CARD' && props.has_card)
				{
					form.use_existing_card = true;
				}else{
					form.use_existing_card = false;
				}

				if(mop!='CARD')
				{
					form.token = null;
				}
			}
		)

		watch(
			() => form.use_existing_card,
			(use_existing_card) => {
				
				if(use_existing_card==true)
				{
					form.token = null;
				}
			}
		)

		watch(()=>form.subscription,(value)=>{

			if(value && value.includes("1M"))
			{
				form.mop = 'CARD';
				payment_available.value = false;
			}else
			{
				payment_available.value = true;
			}
		})

		return {
			form,
			joinTRC,
			acceptToken,
			payment_available
		}
	},
}
</script>
